
import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { bucket: '1-7D', cumulative: 125 },
  { bucket: '8-14D', cumulative: 95 },
  { bucket: '15-30D', cumulative: 55 },
  { bucket: '31-90D', cumulative: -35 },
  { bucket: '91-180D', cumulative: -85 },
  { bucket: '181-365D', cumulative: -45 },
  { bucket: '>1Y', cumulative: 75 },
];

const SLSChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <AreaChart
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="bucket" />
        <YAxis />
        <Tooltip 
          formatter={(value) => [`₹${value} Cr`, 'Cumulative Gap']}
          labelFormatter={(label) => `Time Bucket: ${label}`}
        />
        <Legend />
        <Area 
          type="monotone" 
          dataKey="cumulative" 
          name="Cumulative Gap" 
          stroke="#3b82f6" 
          fill="#93c5fd" 
          fillOpacity={0.6} 
          activeDot={{ r: 6 }} 
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default SLSChart;
